import React from 'react';
function LayersOrder({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M7.09961 4.7C7.09961 4.03726 7.63687 3.5 8.29961 3.5H20.2996C20.9623 3.5 21.4996 4.03726 21.4996 4.7V16.7C21.4996 17.3627 20.9623 17.9 20.2996 17.9H8.29961C7.63687 17.9 7.09961 17.3627 7.09961 16.7V4.7Z" />
      <path
        d="M17 21.1H13H9.5H6C3.99934 21 3.5 20 3.5 18.5V14.5V11V7.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1 3"
      />
    </svg>
  );
}

export default LayersOrder;
